import { useContext } from 'react';
import { HomeFilterContext } from '../../contexts/HomeFilterProvider';

export const useHomeFilter = () => {
    return useContext(HomeFilterContext);
};
